import {NgModule} from '@angular/core';
import {ReportComponent} from './report.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {FollowUpModule} from "../follow-up/follow-up.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FollowUpModule,
  ],
  declarations: [
    ReportComponent,
  ],
  exports: [
    ReportComponent,
  ]
})
export class ReportModule {
}
